import { render } from "./SyHome.vue?vue&type=template&id=1124c703&scoped=true"
import script from "./SyHome.vue?vue&type=script&lang=js"
export * from "./SyHome.vue?vue&type=script&lang=js"

import "./SyHome.vue?vue&type=style&index=0&id=1124c703&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1124c703"]])

export default __exports__